<script lang="ts" setup>
const props = withDefaults(defineProps<{
  itemTextColor?: string
  itemTextColorHover?: string
  itemTextColorPressed?: string
  itemTextColorActive?: string
}>(), {
  itemTextColor: 'white',
  itemTextColorHover: '#9DB7DD',
  itemTextColorPressed: '#9DB7DD',
  itemTextColorActive: '#9DB7DD',
})

const breadcrumbs = useBreadcrumbs()
</script>

<template>
  <n-breadcrumb :theme-overrides="props">
    <n-breadcrumb-item v-for="link in breadcrumbs" :key="link.id">
      <NuxtLink :href="link.path">
        <span class="capitalize">
          {{ link.label }}
        </span>
      </NuxtLink>
    </n-breadcrumb-item>
  </n-breadcrumb>
</template>
